import React from 'react';
import PropTypes from 'prop-types';

import Button from '@material-ui/core/Button';
import Form from 'form/Form';
import { TextField } from 'mui-rff';
import AdminFormWrapper from 'admin/presentational/AdminFormWrapper';
import AdminFormButtons from 'admin/presentational/AdminFormButtons';
import AdminFormFields from 'admin/presentational/AdminFormFields';

const AdminActorSelectorDialogForm = ({ onSubmit, isSubmitting = false }) => {
    const initialValues = {
        actorName: '',
    };

    return (
        <AdminFormWrapper isSubmitting={isSubmitting}>
            <Form
                initialValues={initialValues}
                onSubmit={onSubmit}
            >
                {({ handleSubmit }) => (
                    <form onSubmit={handleSubmit}>
                        <AdminFormFields>
                            <TextField
                                name="actorName"
                                label="Actor name"
                                variant="outlined"
                            />
                        </AdminFormFields>
                        <AdminFormButtons>
                            <Button
                                type="submit"
                                variant="contained"
                                color="primary"
                            >
                                Search
                            </Button>
                        </AdminFormButtons>
                    </form>
                )}
            </Form>
        </AdminFormWrapper>
    );
};

AdminActorSelectorDialogForm.propTypes = {
    searchParameters: PropTypes.object,
    onSubmit: PropTypes.func,
    isSubmitting: PropTypes.bool
};

export default AdminActorSelectorDialogForm;
